import React, { PureComponent } from "react";
import { Link, NavLink, withRouter } from "react-router-dom";
import { Modal, Tabs, Icon, Button } from "antd";
import _ from "lodash";
import {
  Image,
  Logo,
  MenuBurger,
  LanguageSwitcher,
  RegisterForm,
  LoginForm,
  LogoutForm,
  QuoteForm,
  WishlistForm
} from "../components";
import { withRedux } from "../hoc";
import { clearWishlistAction } from "../actions/quotes";
import managementImg from "../assets/images/management.png";
import quoteImg from "../assets/images/quote.png";

const TabPane = Tabs.TabPane;

const mapStateToProps = state => {
  return {
    t: _.get(state, "t"),
    languages: _.get(state, "languages"),
    quotes: _.get(state, "quotes"),
    auth: _.get(state, "auth")
  };
};

const actions = {
  clearWishlistAction
};

@withRouter
@withRedux(mapStateToProps, actions)
export default class Header extends PureComponent {
  state = {
    showLoginModal: false,
    showQuoteModal: false,
    showWishlistModal: false,
    showThankyouModal: false,
    messageToRegisterModal: null
  };
  getWishlistCount = () => {
    return _.size(this.props.quotes.wishlist);
  };
  hasWishlist = () => {
    return this.getWishlistCount() > 0;
  };
  headerMobile = () => {
    return (
      <React.Fragment>
        <ul className="left">
          <li className="menu">
            <MenuBurger />
          </li>
          <li className="management">
            <Image src={managementImg} alt="management" onClick={this.handleClickUserManagement} />
          </li>
        </ul>
        <ul className="center">
          <li className="logo">
            <Link to="/">
              <Logo />
            </Link>
          </li>
        </ul>
        <ul className="right">
          <li
            className={`wishlist ${this.hasWishlist() ? "active" : ""}`}
            onClick={this.handleClickWishlist}
          >
            {this.hasWishlist() && <div className="wishlist-count">{this.getWishlistCount()}</div>}
            <Icon type="heart" />
          </li>
          <li className="quote">
            <Image src={quoteImg} alt="quote" onClick={this.handleClickQuote} />
          </li>
          <li className="language">
            <LanguageSwitcher />
          </li>
        </ul>
      </React.Fragment>
    );
  };
  headerDesktop = () => {
    const { t } = this.props;
    return (
      <React.Fragment>
        <div className="logo">
          <Link to="/">
            <Logo />
          </Link>
        </div>
        <ul className="menu">
          <li>
            <NavLink exact to="/">
              {t("Home")}
            </NavLink>
          </li>
          <li>
            <NavLink exact={false} to="/product">
              {t("Product")}
            </NavLink>
          </li>
          <li>
            <NavLink exact={false} to="/service">
              {t("Service")}
            </NavLink>
          </li>
          <li>
            <NavLink exact={false} to="/tips-trends">
              {t("Tips & Trends")}
            </NavLink>
          </li>
          <li>
            <NavLink exact={false} to="/about">
              {t("About Us")}
            </NavLink>
          </li>
          <li>
            <NavLink exact={false} to="/faq">
              {t("Faq")}
            </NavLink>
          </li>
          <li>
            <NavLink exact={false} to="/contact">
              {t("Contact Us")}
            </NavLink>
          </li>
        </ul>
        <ul className="other">
          <li className="management">
            <Image src={managementImg} alt="management" onClick={this.handleClickUserManagement} />
          </li>
          <li
            className={`wishlist ${this.hasWishlist() ? "active" : ""}`}
            onClick={this.handleClickWishlist}
          >
            {this.hasWishlist() && <div className="wishlist-count">{this.getWishlistCount()}</div>}
            <Icon type="heart" />
          </li>
          <li className="quote">
            <Image src={quoteImg} alt="quote" onClick={this.handleClickQuote} />
          </li>
        </ul>
        <div className="language">
          <LanguageSwitcher />
        </div>
      </React.Fragment>
    );
  };
  showLoginModal = show => {
    if (this.state.showLoginModal !== show) {
      this.setState({
        showLoginModal: show,
        messageToRegisterModal: !show ? null : this.state.messageToRegisterModal
      });
    }
  };
  showQuoteModal = show => {
    if (this.state.showQuoteModal !== show) {
      this.setState({ showQuoteModal: show });
    }
  };
  showWishlistModal = show => {
    if (this.state.showWishlistModal !== show) {
      this.setState({ showWishlistModal: show });
    }
  };
  showThankyouModal = show => {
    if (this.state.showThankyouModal !== show) {
      this.setState({ showThankyouModal: show });
    }
  };
  handleClickUserManagement = () => {
    this.showLoginModal(!this.state.showLoginModal);
  };
  handleClickQuote = () => {
    this.showQuoteModal(!this.state.showQuoteModal);
  };
  handleClickWishlist = () => {
    const { t } = this.props;
    if (this.hasWishlist()) {
      if (this.props.auth.isLogin) {
        this.showWishlistModal(!this.state.showWishlistModal);
      } else {
        this.setState({ messageToRegisterModal: t("Please login first") }, () => {
          this.showLoginModal(true);
        });
      }
    }
  };
  handleCancelModalLogin = () => {
    this.showLoginModal(false);
  };
  handleCancelModalQuote = () => {
    this.showQuoteModal(false);
  };
  handleCancelModalWishlist = () => {
    this.showWishlistModal(false);
  };
  handleCancelModalThankyou = () => {
    this.showThankyouModal(false);
  };
  handleOnRegistered = () => {
    this.showLoginModal(false);
  };
  handleOnLogged = () => {
    this.showLoginModal(false);
  };
  handleOnQuoted = () => {
    this.showQuoteModal(false);
    this.showThankyouModal(true);
  };
  handleOnWishlist = () => {
    this.showWishlistModal(false);
    this.showThankyouModal(true);
    this.props.actions.clearWishlistAction();
  };
  handleOnLogout = () => {
    this.showLoginModal(false);
  };
  renderAlreadyLoginForm = () => {
    const { t } = this.props;
    return (
      <React.Fragment>
        <Tabs defaultActiveKey="logout">
          <TabPane tab={t("Log-Out")} key="logout">
            <LogoutForm onLogout={this.handleOnLogout} />
          </TabPane>
        </Tabs>
      </React.Fragment>
    );
  };
  renderNoLoginForm = () => {
    const { t } = this.props;
    const { messageToRegisterModal } = this.state;
    return (
      <React.Fragment>
        <Tabs defaultActiveKey="register">
          <TabPane tab={t("Register")} key="register">
            <RegisterForm onRegistered={this.handleOnRegistered} message={messageToRegisterModal} />
          </TabPane>
          <TabPane tab={t("Log-In")} key="login">
            <LoginForm onLogged={this.handleOnLogged} />
          </TabPane>
        </Tabs>
      </React.Fragment>
    );
  };
  render() {
    const { showLoginModal, showQuoteModal, showWishlistModal, showThankyouModal } = this.state;
    const { t } = this.props;
    return (
      <header>
        <div className="header mobile-mode">{this.headerMobile()}</div>
        <div className="header desktop-mode container">{this.headerDesktop()}</div>
        <Modal
          visible={showLoginModal}
          footer={null}
          onCancel={this.handleCancelModalLogin}
          wrapClassName="modal-message"
        >
          {this.props.auth.isLogin ? this.renderAlreadyLoginForm() : this.renderNoLoginForm()}
        </Modal>
        <Modal
          title={t("Photo Quote")}
          visible={showQuoteModal}
          footer={null}
          onCancel={this.handleCancelModalQuote}
        >
          <QuoteForm onQuoted={this.handleOnQuoted} />
        </Modal>
        {this.hasWishlist() && (
          <Modal
            title={t("My Quote")}
            visible={showWishlistModal}
            footer={null}
            onCancel={this.handleCancelModalWishlist}
            width={250}
            wrapClassName="modal-wishlist"
          >
            <WishlistForm onWishlist={this.handleOnWishlist} />
          </Modal>
        )}
        <Modal
          visible={showThankyouModal}
          footer={null}
          onCancel={this.handleCancelModalThankyou}
          wrapClassName="modal-thankyou"
        >
          <div
            className="message"
            dangerouslySetInnerHTML={{
              __html: t({
                en: "THANK YOU for your requirements.<br />We’ll get back to you soon !",
                th: "THANK YOU for your requirements.<br />We’ll get back to you soon !"
              })
            }}
          />
          <div className="done-btn">
            <Button type="primary" onClick={this.handleCancelModalThankyou}>
              {t("Done")}
            </Button>
          </div>
        </Modal>
      </header>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Header.js